define([
    "dojo/_base/declare",
    "csi/table/New",
    "csi/xml"
], function(declare,New, xml) {

    return declare(New, {

        toWriterRequest: function(/*FormData?*/fd) {

            var call = this.inherited(arguments);

            var parentField = this.m_formData.getFieldById(xml.ATTR_PARENT)
            // if 2nd field on the form is Parent (e.g. Supplier or Factory),
            // replace ParentURL parameter with Factory or Supplier URL from the form
            if (parentField) {
                fd = fd || this.m_formData; // in case form data isn't loaded yet
                fd.getFieldValue(parentField, true); // remove __Parent__ from automatic ChangeNode
                // Reviewer will be added by @HOperation("OperationsReviewNewFromTemplate")
                // in OperationsReviewable.java on the server
                call.addParameter(xml.PROP_URL_PARENT, xml.ATTR_REF, parentField.getValue());
            }

            return call;
        },

        _canRepeat: function() {
            // summary: disallow Save & New in this case
            return false;
        }

    });
});